
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Robot extends Vue {
  userCode: string = "";
  url:string="";
  user: object;
  created() {
    this.userCode = this.getUserCode();
    const user = JSON.parse(localStorage.logonUser);
     this.url =
     "https://robotapi.fdcyun.com/?channel=corp&redirect=/&biz_id=CORP-XIAOSHOU&version=CORP-XIAOSHOU&userguid=" +
      user.UserGUID +
      "&phone=" +
      user.MobilePhone +
      "&email=" +
      user.Email +
      "&username=" +
      user.UserName +
      "&openid=" +
      user.UserCode +
      "";
  }

  getUserCode() {
    const user = JSON.parse(localStorage.logonUser);
    if (user && user.UserCode) return user.UserCode;

    return "";
  }

}
